export default "__VITE_ASSET__CHY5fAOk__"